module.exports = __webpack_public_path__ + "img/IM.4cdd63be.svg";